<template>
  <div class="js-system-user app-container">
    <app-search>
      <div slot="content">
        <el-row type="flex" :gutter="10" justify="start" align="middle">
          <el-col :span="7">
            <el-form :label-position="'right'" :model="listQuery" :label-width="$t('system.pdpa.labelWidth')">
              <el-form-item :label="$t('system.pdpa.appName') + '：'">
                <el-input v-model="listQuery.appType" :placeholder="$t('system.pdpa.appName')" clearable />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="7">
            <el-form :label-position="'right'" :model="listQuery" :label-width="$t('system.pdpa.labelWidth')">
              <el-form-item :label="$t('system.pdpa.version') + '：'">
                <el-input v-model="listQuery.version" :placeholder="$t('system.pdpa.version')" clearable />
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <app-search-button
        slot="bottom"
        :is-collapse="false"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <app-authorize-button
      :data="authouizeList"
      @click-add="handleAdd"
      @click-update="handleUpdate"
      @click-delete="handleDelete"
      @click-filter="showfilter=true"
    >
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
      />
    </app-authorize-button>
    <el-table
      ref="table"
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      border
      fit
      highlight-current-row
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      style="width: 100%"
      @row-click="rowClick"
      @sort-change="sortChange"
    >
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :min-width="item.width"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <div v-if="item.prop==='appType'">
            <span>
              {{ scope.row[item.prop] | switchText(item.prop) }}
            </span>
          </div>
          <div v-else-if="item.prop==='th_url' || item.prop==='en_url'">
            <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              :content="scope.row[item.prop] ? scope.row[item.prop] : '/'">
              <span slot="reference">{{ scope.row[item.prop] ? scope.row[item.prop] : '/' }}</span>
            </el-popover>
          </div>
          <!-- <div v-else-if="item.prop==='thUrl' || item.prop==='enUrl'">
            <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              :content="scope.row[item.prop] ? scope.row[item.prop]+'&id='+scope.row['pdpaId'] : '/'">
              <span slot="reference">{{ scope.row[item.prop] ? scope.row[item.prop]+'&id='+scope.row['pdpaId'] : '/' }}</span>
            </el-popover>
          </div> -->
          <div v-else>
            {{ scope.row[item.prop] || (scope.row[item.prop]===0?scope.row[item.prop]: '/') }}
          </div>
          <!-- <div>
            {{ scope.row[item.prop] || (scope.row[item.prop]===0?scope.row[item.prop]: '/') }}
          </div> -->
          <!-- 
            

           -->
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        :label="$t('public.operation')"
        width="140px"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <el-button v-if="scope.row['isValid'] == 0" type="primary" size="mini" @click="handleFabu(scope.row)">
              {{ $t('system.pdpa.fabu') }}
            </el-button>
            <el-button v-if="scope.row['isValid'] == 1" :disabled='true' type="default" size="mini" @click="handleFabu(scope.row)">
              {{ $t('system.pdpa.yifabu') }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div :class="[total>0?'visible':'hidden','pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <add-update-dialog
      :visibles.sync="addUpdateVisible"
      :is-edit="isEdit"
      :mobile='mobile'
      :data="isEdit?tableRow:{}"
      @add-complete="addComplete"
      @update-complete="updateComplete"
    />
  </div>
</template>

<script>
// 混入
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { getPageButton } from '@/mixins/getButton'
// request
import { getPagelist, getdelete, getfabu} from '@/api/system/pdpa'

// 组件
import AddUpdateDialog from './components/addUpdateDialog'

// 辅助函数
export default {
  name: 'pdpa',
  components: {
    AddUpdateDialog
  },
  filters: {
    // 后期处理v-html无法编译已定义组件
    switchText(val, type) {
      if (type === 'appType') {
        return val == 0 ? vm.$t('system.pdpa.v2x') : val == 1 ? vm.$t('system.pdpa.playconnect') : ''
      } else {
        return val
      }
    }
  },
  mixins: [pagingMixin, otherHeight, tableStyle, getPageButton],
  data() {
    return {
      mobile: '',
      listQuery: { version: '', appType:'' },
      allStationList: [],
      showfilter: false,
      tableList: [ 
        { value: this.$t('system.pdpa.appName'), prop: 'appType', position: 'center', width: this.$t('system.pdpa.tableWidth.appName'), checked: true },
        { value: this.$t('system.pdpa.version'), prop: 'version', position: 'center', width: this.$t('system.pdpa.tableWidth.version'),  checked: true },
        { value: this.$t('system.pdpa.createTime'), prop: 'createDate', position: 'center', width: this.$t('system.pdpa.tableWidth.createTime'),  checked: true },
        { value: this.$t('system.pdpa.thailandurl'), prop: 'th_url', position: 'center', width: this.$t('system.pdpa.tableWidth.thailandurl'),  checked: true },
        { value: this.$t('system.pdpa.englishurl'), prop: 'en_url', position: 'center', width: this.$t('system.pdpa.tableWidth.englishurl'),  checked: true },
      ],
      // authouizeList: [],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
      addUpdateVisible: false, // 新增修改dialog
      isEdit: false, // false: 新增, true:编辑
      tableRow: {} // 缓存点击tableRow数据
    }
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    }
  },
  mounted() {
    
  },
  methods: {
    // 加载数据
    listLoad() {
      this.listLoading = true
      getPagelist(this.listQuery).then(({ data }) => {
        if (data.code === 0) {
          data.data.forEach(r => {
            if(r.enUrl.indexOf('id=') > 0) {
              // console.log(r.pdpaId)
              r.th_url = r.thUrl
              r.en_url = r.enUrl
            }else{
              // console.log(r.pdpaId,'22')
              r.th_url = r.thUrl+'&id='+r.pdpaId
              r.en_url = r.enUrl+'&id='+r.pdpaId
            }
          })
          this.list = data.data
          this.total = data.total
          let orderSort = 'loginName,realName,roleName,isDisabled,createdOn'
          this.setOrderField(orderSort, this.tableList)
          this.tableRow = {}
        }
        this.listLoading = false
      }).catch(()=>{
         this.listLoading = false
      })
    },
    // 点击列
    rowClick(row, column) {
      const label = column.label
      this.list.some((item, index) => {
        if (item.userId === row.userId) {
          row.$index = index
        }
      })
      this.tableRow = row
      const postData = {
      }
      if (label === this.$t('system.user.accountStatus')) {
        postData.isDisabled = row.isDisabled
        postData.statusvalue = row.isDisabled
        postData.statustype = 0
        this._restStatus(postData)
      }
      
    },
    // 判断tablerow行是否选择
    tableRowIsSlect() {
      const { $index } = this.tableRow
      if ($index === undefined) {
        return false
      } else {
        return true
      }
    },
    // 新增
    handleAdd() {
      this.isEdit = false
      this.addUpdateVisible = true
    },
    // 新增完成
    addComplete() {
      this.listLoad()
      this.$message.success({
        message: this.$t('public.createSuccess'),
        duration: 2 * 1000
      })
    },
    // 编辑
    handleUpdate() {
      if (this.tableRowIsSlect()) {
        this.isEdit = true
        this.addUpdateVisible = true
      } else {
        this.$alert(this.$t('public.updateTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
          .then(() => {})
          .catch(() => {})
      }
    },
    // 编辑成功
    updateComplete() {
      this.listLoad()
      this.$message.success({
        message: this.$t('public.updateSuccess'),
        duration: 2 * 1000
      })
    },
    // 删除
    handleDelete() {
      if (this.tableRow.$index === undefined) {
        this.$alert(this.$t('public.deleteTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
        return
      }
      this.$confirm(this.$t('public.deleteItemTips'), this.$t('public.tips'), {
        confirmButtonText: this.$t('public.define'),
        cancelButtonText: this.$t('public.cancel'),
        type: 'warning'
      })
        .then(() => {
          getdelete(this.tableRow.pdpaId).then(({ data }) => {
            if (data.code === 0) {
              this.listLoad()
              this.$message.success({
                message: this.$t('public.deleteSuccess'),
                duration: 2 * 1000
              })
            }
          })
        })
        .catch(() => {})
    },
    // 发布
    handleFabu(){
      this.$confirm(this.$t('system.pdpa.tipsfabu'), this.$t('public.tips'), {
        confirmButtonText: this.$t('public.define'),
        cancelButtonText: this.$t('public.cancel'),
        type: 'warning'
      })
        .then(() => {
          // var now = new Date();
          // var year = now.getFullYear(); //得到年份
          // var month = (now.getMonth()+1) > 9 ? (now.getMonth()+1) : '0'+(now.getMonth()+1); //得到月份
          // var date = now.getDate() > 9 ? now.getDate() : '0'+now.getDate(); //得到日期
          // const nowdate = year+'-'+month+'-'+date
          var th_url = ''
          var en_url = ''
          if(this.tableRow.enUrl.indexOf('id=') > 0){
            th_url = this.tableRow.thUrl
            en_url = this.tableRow.enUrl
          }else{
            th_url = this.tableRow.thUrl+'&id='+this.tableRow.pdpaId
            en_url = this.tableRow.enUrl+'&id='+this.tableRow.pdpaId
          }
          var postdata = {
            id: this.tableRow.pdpaId,
            enUrl: en_url,
            thUrl: th_url,
            appType: this.tableRow.appType
          }
          getfabu(postdata).then(({ data }) => {
            if (data.code === 0) {
              this.listLoad()
            }
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang='scss' scoped>
.defaults{
  border-bottom: 1px solid #409EFF
}
.errors{
   border-bottom: 1px solid #ff0000
}
</style>
